import { Box } from '@chakra-ui/react';
import styled from 'styled-components';

interface ContainerProps {
  havePictureLogo: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  font-color: #475569;
  font-family: ui-sans-serif, system-ui, sans-serif, Apple Color Emoji,
    Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

  max-height: ${(props) => (props.havePictureLogo ? '80px' : '60px')};
  padding: 10px 0;
  @media (min-width: 768px) {
    height: 100%;
    padding-top: 12px;
    max-height: ${(props) => (props.havePictureLogo ? '80px' : '60px')};
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const ImageContainer = styled(Box)`
  box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 8px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  justify-content: center;
`;

export const Title = styled.p`
  font-weight: 400;

  font-size: 25px;
  margin: 0 8px 0 0;

  @media (min-width: 768px) {
    font-size: 25px;
  }

  color: ${(props) => props.theme.colors.darkerText};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .includeButton:not(:first-child) {
    margin-left: 10px;
  }

  .lighterButton {
    color: ${(props) => props.theme.colors.darkerText};
    background: ${({ theme }) => theme.colors.v2_secondary};

    :hover {
      background: ${({ theme }) => theme.colors.v2_secondary};
      box-shadow: none;
      opacity: 2;
    }
  }

  .downloadButton {
    margin-top: 0px;
    background-color: ${({ theme }) => theme.colors.v2_secondary};
    border-radius: 50%;
    padding: 0.5rem;
    height: auto;
    width: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  .downloadButtonMobile {
    position: relative;
    right: 65px;
  }
`;
